import { render } from "./HeaderSearchBar.vue?vue&type=template&id=8f14537c"
import script from "./HeaderSearchBar.vue?vue&type=script&lang=js"
export * from "./HeaderSearchBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../SINTEZ/OKCU/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__